import sassExports from './_exports.module.scss';

// Casting automatique de variables SASS
// - Si `null` : null
// - Si `true` ou `false` : boolean
// - Si composé uniquement de chiffres : number
// - Dans les autres cas, pas de changement : string
const autocast = (value: string) => {
  if (value === 'null') return null;
  if (value === 'true') return true;
  if (value === 'false') return false;
  if (/^\d+$/.test(value)) return Number(value);
  return String(value);
};

// Extraction d'un sous-ensemble des variables SASS à partir d'un préfixe
// Les valeurs seront automatiquerment converties au format le plus adapté
const getSassVariables = (prefix: string) => {
  const noprefix = (key: string) => key.replace(prefix, '');
  const entries = Object.entries(sassExports)
    .filter(([key]) => key.startsWith(prefix))
    .map(([key, val]) => [noprefix(key), autocast(val)]);
  return Object.fromEntries(entries) as Record<string, unknown>;
};

// Exports des variables avec typage manuel - Voir plus bas
export const BREAKPOINTS = getSassVariables('📏') as Constants['BREAKPOINTS'];
export const SPECIALS = getSassVariables('🦄') as Constants['SPECIALS'];
export const COLORS = getSassVariables('🎨') as Constants['COLORS'];
export const LAYOUT = getSassVariables('📐') as Constants['LAYOUT'];
export const ZINDEX = getSassVariables('🛗') as Constants['ZINDEX'];
export const FONTS = getSassVariables('📝') as Constants['FONTS'];

// Ce type définit la structure des constantes SASS pour TS. Ce type devra être mis à jour
// en cas de changement des constantes exportées. Le script ci-dessous est fourni dans cet
// objectif. Il suffit de le décommenter et de copier le résultat depuis la console.
// Dans l'idéal, ces typings devraient être générés automatiquement via un watcher.
/*/
(() => {
  const Constants = { BREAKPOINTS, COLORS, FONTS, LAYOUT, SPECIALS, ZINDEX };
  const lines = [
    `type Constants = Readonly<{`,
    Object.entries(Constants).map(([module, object]) => [
      `  ${module}: Readonly<{`,
      Object.entries(object).map(([name, value]) => {
        return `    ${name}: ${typeof value};`;
      }),
      `  }>;`,
    ]),
    `}>;`,
  ];
  console.log(lines.flat(3).join('\n'));
  console.log(Constants);
})();
//*/

type Constants = Readonly<{
  BREAKPOINTS: Readonly<{
    XL: number;
    L: number;
    M: number;
    S: number;
    XS: number;
  }>;
  COLORS: Readonly<{
    ACTION_DEFAULT: string;
    ACTION_HOVER: string;
    NEUTRAL_DEFAULT: string;
    NEUTRAL_WHITE: string;
    NEUTRAL_STROKE: string;
    NEUTRAL_DISABLED: string;
    NEUTRAL_PLACEHOLDER: string;
    NEUTRAL_NOTIFICATION: string;
    FLAG_PROMO: string;
    FLAG_LABEL: string;
    FLAG_DARKLABEL: string;
    FLAG_POSITIVE: string;
    FLAG_GIFT: string;
    FLAG_INFO: string;
    FLAG_NEW: string;
    FLAG_PARTY: string;
    FLAG_PUMPKIN: string;
    GROUND_UNDERGROUND: string;
    GROUND_UNDERGROUNDLIGHT: string;
    GROUND_UPPERGROUND: string;
    GROUND_MIDDLE: string;
    GROUND_NEWLIGHT: string;
    GROUND_POSITIVELIGHT: string;
    GROUND_NOTIFICATIONLIGHT: string;
    GROUND_PROMOLIGHT: string;
    LAYER_SHADOW: string;
    LAYER_OVERLAY: string;
    LAYER_INDISPO: string;
  }>;
  FONTS: Readonly<{
    ARTZ: string;
    ICONS: string;
    RETHINK: string;
  }>;
  LAYOUT: Readonly<{
    NAV_HEIGHT: string;
    TREEVIEW_WIDTH: string;
    TREEVIEW_MARGIN: string;
  }>;
  SPECIALS: Readonly<{
    WHITE_OVERLAY: string;
    SHADOW_NORMAL: string;
    CARD_GRADIENT: string;
    LOYALTY_HOVER: string;
  }>;
  ZINDEX: Readonly<{
    categoriesMenuHeaderBlur: number;
    marketingHeadersChevron: number;
    categoriesMenu: number;
    familiesMenu: number;
    footerLegal: number;
    inProgressOrderBanner: number;
    deliveryProgressBanner: number;
    navigationHeader: number;
    sideModalHeader: number;
    sideModalCloseButton: number;
    checkoutLeftContainer: number;
    checkoutRightContainer: number;
    marketingHeadersSliderNav: number;
    checkoutHeader: number;
    landingHeader: number;
    checkoutSummaryButton: number;
    sideModalOverlay: number;
    sideModalInnerContainer: number;
    cartScreen: number;
    modalOverlay: number;
    modalV2Overlay: number;
    formSelectPopover: number;
    googleMapInfoWindow: number;
    googlePlacesAutocompleteLoader: number;
    landingMainLoader: number;
    modalContainer: number;
    modalInnerContainer: number;
    modalV2Container: number;
    modalV2InnerContainer: number;
    googleMapInfoWindowActive: number;
    searchProductScreen: number;
    sideModalContainer: number;
    cartProductsActionsSidePanel: number;
    updatedProductsPanel: number;
    fullPageModalContainer: number;
    signinModal: number;
    slotConfirmationModal: number;
    cgvModal: number;
    actionSheet: number;
    errorModal: number;
    expiredCompleteOrderModal: number;
    zoomedInImageModal: number;
  }>;
}>;
